import api from '../api';
import { serviceReutils } from '../../utils/reutils';

export const ServicePrefixo = {
  ...serviceReutils({ name: 'rotas/v1/prefixo', api }),
};
